{
	"title": "Meets, all sports",
	"subtitle": "{{games}}. Sorted by start time. Click a row to open the meet.",
	"sportFallback": "Sport",
	"groups": {
		"live": "Live",
		"unofficial": "Unofficial",
		"start_list": "Start list",
		"scheduled": "Scheduled",
		"on_hold": "On hold",
		"official": "Official",
		"cancelled": "Cancelled"
	},
	"filters": {
		"label": "Filter the meets",
		"sport": "Sport",
		"allSports": "All sports",
		"discipline": "Discipline",
		"allDisciplines": "All disciplines",
		"pickSportFirst": "Pick a sport first",
		"venue": "Venue",
		"allVenues": "All venues",
		"day": "Day",
		"allDays": "All days",
		"status": "Status",
		"anyStatus": "Any status",
		"medalOnly": "Medal events only",
		"event": "Event",
		"allEvents": "All events",
		"date": "Date",
		"meetNo": "Meet no.",
		"anyMeetNo": "Any number"
	},
	"table": {
		"sport": "Sport",
		"event": "Event",
		"venue": "Venue",
		"entries": "Entries",
		"status": "Status",
		"action": "Action",
		"open": "Open meet {{meet}}",
		"delete": "Delete meet {{meet}}",
		"medalEvent": "Medal event",
		"medalYes": "Yes",
		"medalNo": "No",
		"meetNo": "Meet {{meet}}",
		"meetNoCol": "Meet no.",
		"dateTime": "Date & time",
		"stage": "Stage",
		"group": "Group",
		"noGroup": "—",
		"pool": "{{phase}} {{pool}}",
		"poolOf": "{{phase}} {{pool}}, {{n}} of {{total}}",
		"phaseOf": "{{phase}}, {{n}} of {{total}}",
		"unitOf": {
			"HEAT": "Heat {{n}} of {{total}}",
			"QUALIFICATION": "Qualification {{n}} of {{total}}",
			"REPECHAGE": "Repechage {{n}} of {{total}}",
			"QUARTERFINAL": "Quarterfinal {{n}} of {{total}}",
			"SEMIFINAL": "Semifinal {{n}} of {{total}}"
		},
		"court": "{{venue}}, {{court}}",
		"entriesPending": "To be decided",
		"noEntries": "None yet",
		"noTime": "No time yet",
		"noVenue": "No venue yet",
		"report": "Report for meet {{meet}}"
	},
	"list": {
		"showing_one": "Showing {{n}} meet",
		"showing_other": "Showing {{n}} meets",
		"showingDay_one": "Showing {{n}} meet on {{day}}",
		"showingDay_other": "Showing {{n}} meets on {{day}}",
		"more": "Next {{n}}",
		"allLoaded": "That is every meet that matches."
	},
	"empty": {
		"filteredTitle": "No meets match these filters",
		"filteredBody": "Change the filters, or reset them to see every meet.",
		"reset": "Reset filters",
		"noneTitle": "No meets are scheduled in this games yet",
		"noneBody": "Meets get their start times in GMS.",
		"noGamesTitle": "No games are set up yet",
		"noGamesBody": "Games are created in GMS. Ask your administrator."
	},
	"errors": {
		"gamesTitle": "The games could not load",
		"retry": "Try again"
	},
	"sport": {
		"subtitle": "{{code}} · {{games}}. Pick a discipline, then click a meet to open it.",
		"meets_one": "{{n}} meet",
		"meets_other": "{{n}} meets",
		"loading": "Loading the sport…",
		"standings": "Standings & brackets",
		"notInGamesTitle": "This sport is not part of {{games}}",
		"notInGamesBody": "Switch games in the sidebar, or pick a sport under Meets.",
		"allSports": "All sports",
		"noDisciplinesTitle": "This sport has no disciplines yet",
		"noDisciplinesBody": "Disciplines are set up in GMS.",
		"listLabel": "{{discipline}} meets",
		"listError": "The meets could not load",
		"disciplines": "Disciplines",
		"code": "CODE: {{code}}",
		"noMeets": "No {{discipline}} meets yet.",
		"noMedalMeets": "No {{discipline}} medal events yet. Turn off “Medal events only” to see every meet.",
		"noMeetsFiltered": "No {{discipline}} meets match these filters."
	},
	"standings": {
		"titleFor": "Standings & Brackets – {{discipline}}",
		"event": "Event",
		"noEvents": "No events in {{discipline}} yet.",
		"close": "Close"
	},
	"addMeet": {
		"button": "Add meet",
		"title": "Add meets",
		"subtitle": "{{sport}}, {{games}}. New meets go onto the schedule at once.",
		"sections": {
			"result": "Result settings"
		},
		"discipline": "Discipline",
		"event": "Event",
		"pickEvent": "Pick an event",
		"pickEventFirst": "Pick an event first",
		"meetNo": "Meet number",
		"start": "Start date & time",
		"end": "End date & time",
		"firstEnd": "First end",
		"endSeriesHint": "Each meet lasts as long as the first.",
		"remarks": "Remarks",
		"remarksHint": "{{used}} of {{max}} characters. Shown with the meet on every OVR screen.",
		"namedAs": "Named “{{name}}”",
		"group": "Group",
		"noGroup": "No group",
		"groupName": "Group {{group}}",
		"groupHint": "The meet counts in Group {{group}}’s standings.",
		"pool": "Pool",
		"noPool": "No pool",
		"poolName": "Pool {{group}}",
		"poolHint": "The meet counts in Pool {{group}}’s standings.",
		"bracket": "Bracket position",
		"bracketFirst": "First bracket position",
		"bracketHint": "Its place in the bracket, top to bottom. Empty = after the others ({{next}}).",
		"bracketHintSeveral": "The next meets take the positions after it.",
		"several": "Add several meets at once",
		"combined": {
			"check": "Decathlon / heptathlon: add every discipline",
			"kind": "Combined event",
			"resultSettings": "Each discipline is scored as its own: races on time, jumps and throws on distance.",
			"hint_one": "Adds {{n}} meet, one per discipline, over two days. Points are worked out from each result.",
			"hint_other": "Adds {{n}} meets, one per discipline, over two days. Points are worked out from each result.",
			"kinds": {
				"DECATHLON": "Decathlon (10 disciplines)",
				"HEPTATHLON": "Heptathlon (7 disciplines)"
			},
			"name": {
				"100": "100 m",
				"200": "200 m",
				"400": "400 m",
				"800": "800 m",
				"1500": "1500 m",
				"100H": "100 m hurdles",
				"110H": "110 m hurdles",
				"HJ": "High jump",
				"PV": "Pole vault",
				"LJ": "Long jump",
				"SP": "Shot put",
				"DT": "Discus throw",
				"JT": "Javelin throw"
			}
		},
		"phase": "Stage",
		"pickPhase": "Pick a stage",
		"stageCreatedOnSave": "New: added when you save",
		"stageNewHint": "This event has no such stage yet: it is added when you save.",
		"poolStage": "Pool",
		"preliminaryStage": "Preliminary round",
		"phaseMeets_one": "{{n}} meet",
		"phaseMeets_other": "{{n}} meets",
		"count": "How many meets",
		"countHint": "1 to {{max}}",
		"firstNo": "First meet number",
		"names": "New meets",
		"rowName": "Name of meet {{no}}",
		"nameOf": {
			"HEAT": "Heat {{n}}",
			"QUALIFICATION": "Qualification {{n}}",
			"REPECHAGE": "Repechage {{n}}",
			"QUARTERFINAL": "Quarterfinal {{n}}",
			"SEMIFINAL": "Semifinal {{n}}"
		},
		"nameNumbered": "Match {{n}}",
		"nameStageNumbered": "{{phase}} {{n}}",
		"noTime": "No time",
		"firstStart": "First start",
		"venueTime": "At the venue: {{time}} ({{zone}})",
		"interval": "Minutes between meets",
		"venue": "Venue",
		"noVenue": "No venue yet",
		"area": {
			"COURT": "Court",
			"RING": "Ring",
			"MAT": "Mat",
			"PISTE": "Piste",
			"PITCH": "Pitch",
			"TABLE": "Table",
			"LANE": "Lane",
			"RANGE": "Range",
			"RINK": "Rink",
			"AREA": "Area"
		},
		"wholeVenue": "The whole venue",
		"scheduleStatus": "Schedule status",
		"resultAsEvent": "As the event: {{family}}, {{type}}, {{direction}}.",
		"resultPickEvent": "Pick an event to see its result settings.",
		"family": "Result family",
		"resultTypeLabel": "Result type",
		"direction": "Ranking",
		"asEvent": "As the event",
		"lowerBetter": "lower is better",
		"higherBetter": "higher is better",
		"resultType": {
			"TIME": "time",
			"DISTANCE": "distance",
			"POINTS": "points",
			"SCORE": "score",
			"WEIGHT": "weight",
			"NONE": "win or lose"
		},
		"phaseType": {
			"QUALIFICATION": "Qualification",
			"HEAT": "Heats",
			"GROUP": "Group",
			"ROUND": "Round",
			"R128": "Round of 128",
			"R64": "Round of 64",
			"R32": "Round of 32",
			"R16": "Round of 16",
			"QUARTERFINAL": "Quarterfinals",
			"SEMIFINAL": "Semifinals",
			"REPECHAGE": "Repechage",
			"BRONZE": "Bronze medal match",
			"FINAL": "Final",
			"RANKING": "Ranking round",
			"TIEBREAK": "Tiebreak"
		},
		"summaryRange_one": "Adds {{n}} meet to {{phase}}, {{from}} to {{to}}",
		"summaryRange_other": "Adds {{n}} meets to {{phase}}, {{from}} to {{to}}",
		"summaryAt_one": "Adds {{n}} meet to {{phase}}, {{from}}",
		"summaryAt_other": "Adds {{n}} meets to {{phase}}, {{from}}",
		"summaryUnscheduled_one": "Adds {{n}} meet to {{phase}}, not scheduled yet",
		"summaryUnscheduled_other": "Adds {{n}} meets to {{phase}}, not scheduled yet",
		"submit_one": "Add {{n}} meet",
		"submit_other": "Add {{n}} meets",
		"cancel": "Cancel",
		"done_one": "{{n}} meet added to {{phase}}",
		"done_other": "{{n}} meets added to {{phase}}",
		"phaseCreated": "The stage “{{phase}}” was created, but the meets were not. It stays selected: fix what is marked and add the meets again.",
		"orderFailed": "The stage “{{phase}}” was added after the event's other stages: its place could not be changed.",
		"orderFailedInline": "It was added after the event's other stages: its place could not be changed.",
		"form": {
			"pickEvent": "Pick an event",
			"pickPhase": "Pick a stage, or add a new one",
			"nameRequired": "Enter a name",
			"tooLong": "{{max}} characters at most",
			"meetNoRequired": "Enter a meet number",
			"meetNoTaken": "Meet {{no}} is already used in this event",
			"meetNoRepeated": "Each meet number may appear only once",
			"meetIdRepeated": "Each meet may appear only once",
			"countRange": "Enter a number from 1 to {{max}}",
			"intervalRange": "Enter minutes from 0 to {{max}}",
			"badTime": "Enter a date and time",
			"invalidField": "Check this field",
			"endNeedsStart": "Set a start time first",
			"endBeforeStart": "The end is before the start",
			"bracketRange": "Enter a whole number from 1 to {{max}}, or leave it empty"
		},
		"errors": {
			"meetNoTaken": "Meet {{no}} is already used in this event. Choose another first number.",
			"venueGone": "That venue no longer exists. Pick another.",
			"phaseGone": "That stage no longer exists. Pick another.",
			"eventGone": "That event no longer exists.",
			"invalidField": "The server refused this value. Check it."
		},
		"banner": {
			"invalid": "Some values were refused. Check the marked fields and try again.",
			"locked": "The medal desk has locked this event. Nothing can be added until it is unlocked.",
			"forbidden": "Your role can view meets but not add them.",
			"notFound": "That event no longer exists. Close and pick another.",
			"offlinePhase": "No answer from the server. Nothing was added. Try again.",
			"offlineMeets": "No answer from the server. Try again: meets that were already added are not added twice.",
			"auth": "Your session ended. Sign in again, then add the meets.",
			"idTaken": "These meets could not be added. Close the drawer and try again.",
			"generic": "The meets could not be added ({{code}}). Try again, or tell your administrator."
		},
		"rubbers": {
			"check_one": "Create its {{n}} match with each tie",
			"check_other": "Create its {{n}} matches with each tie",
			"list": "Each tie gets: {{list}}. The tie’s two teams are copied to them when its start list is saved.",
			"off": "Only the ties are created; their matches can be added later.",
			"checking": "Checking whether this event plays team ties…",
			"failed": "Could not tell whether this event plays team ties, so its matches cannot be created with them. Close and open the form again."
		},
		"doneTies_one": "{{n}} tie added to {{phase}}, with its {{rubbers}} matches",
		"doneTies_other": "{{n}} ties added to {{phase}}, with their {{rubbers}} matches"
	},
	"bulk": {
		"button": "Bulk action",
		"buttonCount": "Bulk action ({{n}})",
		"select": "Select meet {{meet}}",
		"selectAll": "Select every meet shown",
		"max": "At most {{max}} meets at a time.",
		"title_one": "Bulk action on {{n}} meet",
		"title_other": "Bulk action on {{n}} meets",
		"action": "Action",
		"setStatus": "Change schedule status",
		"delete": "Delete meets",
		"status": "Schedule status",
		"warnStatus_one": "{{n}} meet will be set to {{status}}. Meets already in that status are skipped.",
		"warnStatus_other": "{{n}} meets will be set to {{status}}. Meets already in that status are skipped.",
		"warnDelete_one": "{{n}} meet will be deleted for good, with its results and, for a team tie, its matches. A meet with awarded medals, or whose winners already play in a later meet, is skipped.",
		"warnDelete_other": "{{n}} meets will be deleted for good, with their results and, for team ties, their matches. A meet with awarded medals, or whose winners already play in a later meet, is skipped.",
		"password": "Your password",
		"passwordHint": "Enter your own password to confirm.",
		"confirmStatus_one": "Change {{n}} meet",
		"confirmStatus_other": "Change {{n}} meets",
		"confirmDelete_one": "Delete {{n}} meet",
		"confirmDelete_other": "Delete {{n}} meets",
		"doneStatus_one": "{{n}} meet set to {{status}}.",
		"doneStatus_other": "{{n}} meets set to {{status}}.",
		"doneDelete_one": "{{n}} meet deleted.",
		"doneDelete_other": "{{n}} meets deleted.",
		"resultTitle": "{{done}} done, {{skipped}} skipped",
		"skippedBodyStatus": "These meets were left as they are:",
		"skippedBodyDelete": "These meets were not deleted:",
		"close": "Close",
		"why": {
			"NOT_FOUND": "It no longer exists.",
			"LOCKED": "Its event is locked by the medal desk.",
			"HAS_RESULTS": "It holds results. Clear them on the meet first.",
			"TSR_LIVE": "TSR is holding live scores for it. Delete it on its own meet screen, which warns first.",
			"HAS_MEDALS": "It holds awarded medals.",
			"HAS_CHILDREN": "It is a team tie with rubbers.",
			"IS_SOURCE": "A later meet it sent competitors to has already started.",
			"UNCHANGED": "It already has that status.",
			"CHANGED": "Someone changed it meanwhile. Reload and try again."
		}
	},
	"report": {
		"button": "Reports",
		"title": "{{sport}} reports",
		"close": "Close",
		"meetTitle": "Start list / Results",
		"meetHint": "One meet’s A4 sheet: the start list until results are in, the results after. Print it from there.",
		"meet": "Meet",
		"openMeet": "Open the sheet",
		"noMeets": "No meets are listed.",
		"scheduleTitle": "Competition schedule",
		"scheduleHint": "Every {{discipline}} meet, day by day.",
		"scheduleHintFiltered": "The {{discipline}} meets your filters list, day by day.",
		"printSchedule": "Print the schedule",
		"truncated": "Only the first {{n}} meets fit on the schedule. Narrow the filters to print the rest.",
		"later": "Medallists, medal standings and results books come later.",
		"path": "{{sport}} · {{discipline}}",
		"scheduleCount_one": "{{n}} meet.",
		"scheduleCount_other": "{{n}} meets.",
		"filtered": "Filtered on the meets page.",
		"zone": "Times are in {{zone}}.",
		"noTime": "No time yet",
		"medalYes": "Medal",
		"printedAt": "Printed {{at}}",
		"col": {
			"time": "Time",
			"meet": "Meet",
			"event": "Event",
			"stage": "Stage",
			"venue": "Venue",
			"status": "Status",
			"medal": "Medal"
		}
	}
}
